module.exports = new __parcel__URL__("Logo-Instagram.328fe97e.svg").toString();